import {_hasProperty} from '../common/helpers/HelperFunc'

export default class PriceVO {
	id = ''
	serviceName = ''
	serviceId = ''
	priceNew = ''
	priceNewFormatted = ''
	basePriceNew = ''
	priceRenew = ''
	priceRenewFormatted = ''
	basePriceRenew = ''
	monthlyPriceNew = ''
	monthlyBasePriceNew = ''
	term = ''
	termEn = ''
	currency = ''
	discount = 0
	discount_sum = 0
	isPremium = 0
	termClear = 1;
	// EUR
	priceNewAdditional = ''
	basePriceNewAdditional = ''
	priceRenewAdditional = ''
	priceRenewFormattedAdditional = ''
	basePriceRenewAdditional = ''
	monthlyPriceNewAdditional = ''
	monthlyBasePriceNewAdditional = ''
	currencyAdditional = ''
	discountAdditional = 0
	discount_sumAdditional = 0

	constructor(params) {
		for (const property in this) {
			if (_hasProperty(this, property) && _hasProperty(params, property)) {
				this[property] = params[property]
			}
		}

		this.priceNew = parseFloat(this.priceNew).toFixed(2)
		this.basePriceNew = parseFloat(this.basePriceNew).toFixed(2)
		this.priceRenew = parseFloat(this.priceRenew).toFixed(2)
		this.basePriceRenew = parseFloat(this.basePriceRenew).toFixed(2)
		this.monthlyPriceNew = parseFloat(this.monthlyPriceNew).toFixed(2)
		this.monthlyBasePriceNew = parseFloat(this.monthlyBasePriceNew).toFixed(2)
		this.discount = parseInt(this.discount)
		this.discount_sum = parseInt(this.discount_sum)
		this.termClear = parseInt(this.termClear);
	}
}
